import RS_Form from "./RS_NaHrazi_Form.svelte";

let target = document.querySelector("div#rezervace");

if(target) {
    const form = new RS_Form({
        target: target,
        props: {
            
        }
    });
}
else {
    console.log("Došlo k chybě, nelze najít RS_Form prvek v dokumentu.");
}
